











































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import NumberStepper from '@/components/Views/Cart/NumberStepper.vue';
import {DateTime} from 'luxon';
import {nil} from '@/common';
@Component({
    components: {
        NumberStepper,
    },
})
export default class TimePicker extends Vue {
    @Prop({default: () => null})
    public value!: string;

    @Prop({default: 'HH:mm'})
    public format!: string;

    @Prop({default: false})
    public disabled!: boolean;

    private hour = 1;
    private minute = 0;
    private isAM = false;

    @Watch('isAM')
    public onIsAMChanged(value: boolean, oldValue: boolean) {
        this.emit();
    }
    @Watch('hour')
    public onHourChanged(value: number, oldValue: number) {
        this.emit();

    }
    @Watch('minute')
    public onMinuteChanged(value: number, oldValue: number) {
        this.emit();
    }
    @Watch('disabled')
    public onDisabledChanged(value: boolean, oldValue: boolean) {
        if (oldValue && !value) { this.emit(); }
    }

    @Watch('value')
    public onValueChanged(value: string, oldValue: string){
        this.setFromValue();
    }

    public mounted(){
        this.setFromValue();
    }
    public created(){
        this.setFromValue();
    }

    public emit() {
        this.$emit('input', this.formattedTime);
    }

    public setFromValue() {
        if (nil(this.value)) { return; }
        const index = Number(this.valueAsDateTime.toFormat('hh'));
        if (index === 12) {
            this.hour = 0;
        } else {
            this.hour = index;
        }
        this.minute = Number(this.valueAsDateTime.toFormat('mm'));
        this.isAM = this.valueAsDateTime.hour < 12;
    }

    public get valueAsDateTime() {
        return DateTime.fromFormat(this.value, this.format);
    }

    public get formattedTime() {
        let as24 = this.hour;
        if (this.isAM && this.hour === 12) {
            as24 = 0;
        } else if (!this.isAM && this.hour !== 12) {
            as24 += 12;
        }
        const d = DateTime.fromObject({hour: as24, minute: this.minute});
        return d.toFormat(this.format);
    }

    public minuteMin() {
        (this.$refs.hourField as any).decr();
        this.minute = 59;
    }
    public minuteMax() {
        (this.$refs.hourField as any).incr();
        this.minute = 0;
    }
    public hourMax() {
        this.hour = 0;
        this.isAM = !this.isAM;
    }
    public hourMin() {
        this.hour = 11;
        this.isAM = !this.isAM;
    }
}
